import { SemiBold, Regular, Bold, Medium } from "@src/apps/styles/common-style";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const styles: any = {
  // Main Container
  navigationBarRedesign: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
    position: 'relative',
    width: '100%',      // was '1610px' — fixed width broke responsive/zoom behavior
    minWidth: '0',      // was '1610px' — removed hard floor that caused overflow
    maxWidth: '100%',
    background: '#F1F4F7',
  },

  // Header Container
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
    width: '100%',      // was '1287px' — fixed width prevented fluid scaling
    maxWidth: '100%',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  // Header
  header: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px',
    isolation: 'isolate',
    width: '100%',      // was '1287px' — fixed width prevented fluid scaling
    maxWidth: '100%',
    border: '1px solid #FFFFFF',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  desktopNavHidden: {
    display: 'none',
  },

  mobileNavBar: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    minHeight: '48px',
    padding: '8px 16px',
    background: '#002677',
    color: '#FFFFFF',
    position: 'relative',
    zIndex: 3001,
  },

  mobileMenuButton: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    width: '36px',
    height: '36px',
    padding: '0px',
    border: '1px solid rgba(255, 255, 255, 0.45)',
    borderRadius: '4px',
    background: 'transparent',
    cursor: 'pointer',
  },

  mobileMenuIconLine: {
    display: 'block',
    width: '18px',
    height: '2px',
    background: '#FFFFFF',
    borderRadius: '2px',
  },

  mobileNavTitle: {
    fontFamily: SemiBold,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF',
  },

  mobileDrawerOverlay: {
    position: 'absolute',
    top: '0',
    left: 0,
    right: 0,
    minHeight: '100vh',
    zIndex: 3000,
    background: 'rgba(0, 0, 0, 0.4)',
  },

  mobileDrawer: {
    boxSizing: 'border-box',
    width: 'min(86vw, 360px)',
    height: '100vh',
    background: '#002677',
    boxShadow: '4px 0px 16px rgba(0, 0, 0, 0.22)',
    display: 'flex',
    flexDirection: 'column',
  },

  mobileDrawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    background: '#002677',
    color: '#FFFFFF',
  },

  mobileDrawerTitle: {
    fontFamily: SemiBold,
    fontSize: '18px',
    lineHeight: '22px',
    color: '#FFFFFF',
  },

  mobileDrawerCloseButton: {
    width: '32px',
    height: '32px',
    border: 'none',
    background: 'transparent',
    color: '#FFFFFF',
    fontSize: '28px',
    lineHeight: '28px',
    cursor: 'pointer',
  },

  mobileDrawerContent: {
    overflowY: 'auto',
    padding: '12px 0px 24px',
    background: '#002677',
  },

  mobileDrawerSection: {
    padding: '8px 0px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.25)',
  },

  mobileDrawerSectionTitle: {
    fontFamily: Bold,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px',
    color: '#FFFFFF',
    textTransform: 'uppercase',
    padding: '8px 16px',
  },

  mobileDrawerItem: {
    display: 'flex',
    flexDirection: 'column',
  },

  mobileDrawerParentButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '12px 16px',
    border: 'none',
    background: '#002677',
    color: '#FFFFFF',
    fontFamily: SemiBold,
    fontSize: '15px',
    lineHeight: '20px',
    textAlign: 'left',
    cursor: 'pointer',
  },

  mobileDrawerChevron: {
    color: '#FFFFFF',
    fontSize: '20px',
    lineHeight: '20px',
  },

  mobileDrawerChildren: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 0px 6px 16px',
  },

  mobileDrawerChildGroup: {
    display: 'flex',
    flexDirection: 'column',
  },

  mobileDrawerSectionLabel: {
    padding: '8px 16px 4px',
    color: '#FFFFFF',
    fontFamily: SemiBold,
    fontSize: '14px',
    lineHeight: '18px',
  },

  mobileDrawerChildButton: {
    width: '100%',
    padding: '8px 16px',
    border: 'none',
    background: '#1D3B7C',
    color: '#FFFFFF',
    fontFamily: Regular,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'left',
    cursor: 'pointer',
  },

  mobileDrawerDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  // Main Nav
  mainNav: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '24px 48px',
    gap: '40px',
   // width: '1287px',
    maxWidth: '100%',
    height: '40px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
    zIndex: 2,
  },

  // Content Wrapper
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '16px',
    width: '100%',
    height: '40px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 1,
  },

  // UHC Insights Logo
  uhcInsights: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '10px',
    // width: '215.05px',
    height: '40px',
    flex: 'none',
    marginLeft:'-10px',
    order: 0,
    flexGrow: 0,
  },

  logoVector: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
    gap: '8px',
    width: '125.05px',
    height: '40px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  vector: {
    width: '125.05px',
    height: '40px',
    background: '#002677',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  line2: {
    height: '28px',
    border: '1.5px solid #4B4D4F',
   // transform: 'rotate(90deg)',
    flex: 'none',
    order: 1,
    flexGrow: 0,
  },

  frame24: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 2px',
    gap: '8px',
    width: '70px',
    height: '29px',
    flex: 'none',
    order: 2,
    flexGrow: 0,
  },

  insightsText: {
    width: '66px',
    height: '13px',
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4D4F',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  // Action Bar
  actionBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '16px',
    height: '40px',
    flex: 'none',
    // order: 1,
    // flexGrow: 1,
  },

  // Search Input
  searchInputPiece: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px 8px',
    gap: '4px',
    width: '400px',
    height: '40px',
    background: '#FFFFFF',
    border: '1px solid #4B4D4F',
    borderRadius: '4px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  searchIcon: {
    display: 'flex',
    width: '35px',
    height: '18px',
    flex: 'none',
    order: 3,
    flexGrow: 0,
    gap:'2px'
  },

  placeholderText: {
    width: '340px',
    height: '11px',
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4D4F',
    border: 'none',
    outline: 'none',
    flex: 'none',
    order: 1,
    flexGrow: 1,
  },

  // Utility Nav Links
  utilityNavLinks: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '16px',
    width: '284px',
    height: '17px',
    flex: 'none',
    order: 2,
    flexGrow: 0,
    marginLeft:'253px'
  },

  link: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
    // width: '130px',
    height: '17px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  linkAccount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
   // width: '118px',
    height: '17px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  linkMenu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    padding: '0px',
    width: '20px',
    height: '17px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    marginLeft: '-10px'
  },

  textIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '4px',
    height: '17px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
  },

  linkText: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    color: '#196ECF',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    cursor: 'pointer',
  },

  accountCircle: {
    width: '16px',
    height: '16px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  expandMore: {
    width: '16px',
    height: '16px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
  },

  expandMoreWhite: {
    width: '16px',
    height: '16px',
    flex: 'none',
    order: 1,
    flexGrow: 0
  },

  expandMoreWhiteSecondary: {
    width: '16px',
    height: '16px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    marginTop: '20px'
  },

  // Top Level Nav - Primary
  topLevelNav: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px',
    width: '100%',
    minWidth: '0',
    maxWidth: '100%',
    height: '33px',
    background: '#002677',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
    zIndex: 1,
  },

  navItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px 0px 0px 40px',
    boxSizing: 'border-box',
    width: '100%',
    height: '33px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  navItemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flexStart',
    padding: '0px',
    height: '33px',
    flex: 'none',
    flexGrow: 0,
  },

  flyoutMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    height: '33px',
    background: '#002677',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    position: 'relative',
  },

  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px 8px 4px',
    gap: '4px',
    height: '33px',
    background: '#002677',
    border: 'none',
    cursor: 'pointer',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    ':disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },

  buttonText: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  // Top Level Nav - Secondary
  topLevelNavSecondary: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px',
    width: '100%',
    minWidth: '0',
    maxWidth: '100%',
    height: '49px',
    background: '#1D3B7C',
    flex: 'none',
    order: 2,
    alignSelf: 'stretch',
    flexGrow: 0,
    zIndex: 0,
  },

  navItemsSecondary: {
    display: 'flex',
    fontFamily: Regular,
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px 0px 0px 105px',
    boxSizing: 'border-box',
    width: '100%',
    background: '#1D3B7C',
    height: '49px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  navItemsContainerSecondary: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flexStart',
    padding: '0px',
    height: '49px',
    flex: 'none',
    flexGrow: 0,
  },

  flyoutMenuSecondary: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    height: '49px',
    background: '#1D3B7C',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  buttonSecondary: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px 8px 4px',
    gap: '4px',
    height: '49px',
    background: '#1D3B7C',
    border: 'none',
    cursor: 'pointer',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    ':disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },

  buttonTextSecondary: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '14px',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
    flex: 'none',
    order: 0,
    flexGrow: 0,
  },

  // Provider Performance label (text above the menu)
  providerPerformanceLabel: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '14px',
    color: '#FFFFFF',
    textAlign:'left'
  },
   providerLabel: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '14px',
    color: '#FFFFFF',
    marginLeft: '0px',
    textAlign: 'left',
  },

  // Single Tax ID label (displayed under provider name for single TIN in multi-TIN flow)
  singleTaxIdLabel: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: '#FFFFFF',
   // marginTop: '4px',
    textAlign: 'left' as const,
  },

  // Dropdown Menu Styles - Figma Exact Specifications
  // Main dropdown container
  dropdownMenu: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '24px',
    gap: '32px',
    position: 'absolute',
    minWidth: '211px',
    left: '0px',
    top: '33px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 4px -2px rgba(0, 0, 0, 0.16)',
    borderRadius: '4px',
    zIndex: 1000,
  },

  // Triangle pointer (arrow pointing up to clicked menu item)
  dropdownTriangle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 0px 0px 36px',
    gap: '10px',
    position: 'absolute',
    width: '58px',
    height: '11px',
    left: '0px',
    top: '-11px',
    overflow: 'visible',
  },

  // SVG triangle shape
  triangleSvg: {
    width: '22px',
    height: '11px',
    fill: '#FFFFFF',
    filter: 'drop-shadow(0px -2px 2px rgba(0, 0, 0, 0.1))',
  },

  // Columns container
  dropdownColumns: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '32px',
    flexGrow: 1,
  },

  // Single column
  dropdownColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '0px',
    width: '100%',
    maxWidth: '300px',
    flexGrow: 1,
  },

  // Column heading (category name like "Network Management")
  columnHeading: {
    fontFamily: Bold,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '120%',
    color: '#323334',
    alignSelf: 'stretch',
  },

  // Non-clickable header option shown inside dropdown list
  dropdownHeaderItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '1px',
    alignSelf: 'stretch',
    cursor: 'default',
    userSelect: 'none',
  },

  dropdownHeaderText: {
    fontFamily: Bold,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '120%',
    letterSpacing: '0%',
    color: '#323334',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },

  // Links container
  dropdownLinks: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '8px',
    alignSelf: 'stretch',
  },

  // Individual link item wrapper
  dropdownItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '1px',
    alignSelf: 'stretch',
  },

  // Link element
  dropdownLink: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    cursor: 'pointer',
    textDecoration: 'none',
    alignSelf: 'stretch',
    border: 'none',
    background: 'transparent',
    width: '100%',
    textAlign: 'left',
  },

  // Link text
  dropdownItemText: {
    fontFamily: SemiBold,
    fontStyle: 'normal',
   // fontWeight: 600,
    fontSize: '14px',
    lineHeight: '140%',
    display: 'flex',
    alignItems: 'center',
    color: '#0C55B8',
    flexGrow: 1,
    textDecoration: 'none',
  },

  // Hover effect for links (applied via inline style)
  dropdownItemHover: {
    backgroundColor: 'rgba(12, 85, 184, 0.05)',
  },

  // Disabled state
  dropdownItemDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  // Nested dropdown items
  nestedDropdown: {
    paddingLeft: '16px',
  },

  expandMoreDropdown: {
    width: '16px',
    height: '16px',
    marginLeft: '8px',
  },

  nestedDropdownItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
  },

  // Tax ID dropdown specific styles
  taxIdDropdownOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '8px 0px 8px 12px', // Removed right padding
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    width: '100%',
    textAlign: 'left',
    minWidth: '200px',
  },

  taxIdDropdownOptionSelected: {
    backgroundColor: '#F0F0F0',
  },

  taxIdDropdownOptionValue: {
    fontFamily: SemiBold,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px', // Changed from 14px to 16px
    lineHeight: '22px', // Changed from 18px to 22px
    color: '#2d2d39', // Default color for unselected items
    letterSpacing: '0.2px',
    width: '100%',
  },

  taxIdDropdownOptionValueSelected: {
    color: '#196ecf', // Selected item color
  },

  taxIdDropdownOptionName: {
    fontFamily: Medium,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px', // Changed from 16px to 14px
    color: '#2d2d39', // Changed from #666666 to #2d2d39
    letterSpacing: '0.2px',
    width: '166px',
  },

  taxIdSelectedValue: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },

  taxIdSelectedValueText: {
    fontFamily: SemiBold,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#FFFFFF',
  },

  taxIdSelectedValueName: {
    fontFamily: Regular,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#FFFFFF',
    marginTop: '2px',
    opacity: 0.9,
  },
};
